<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <p>会员资讯</p>
          <p class="tips">本平台资讯为付费资讯，仅对付费用户开放</p>
          <p class="vip-btn" @click="toUserSet">成为付费用户</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 资讯列表 start -->
    <div class="list-box">
      <p class="list-title" @click="toNews('newslist')">会员资讯（仅对付费会员开放）</p>
      <div class="list-content">
        <div class="content-item" v-for="(item, index) in listItem" :key="index">
          <img :src="item.imgUrl">
          <div class="content-text">
            <el-link class="content-title" :underline="false">{{item.title}}</el-link>
            <p class="content-des">{{item.des}}</p>
            <div class="content-btns">
              <el-button size="mini" v-for="(ele, index) in item.btnDes" :key="index" @click="toNews(ele.type)" round>{{ele.text}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资讯列表 end -->

    <!-- 分页 start -->
    <el-pagination
      class="page"
      background
      @current-change="changePage"
      layout="prev, pager, next"
      :page-size='4'
      :total="8">
    </el-pagination>
    <!-- 分页 end -->

  </div>
</template>

<script>
import banner1 from '@/assets/imgs/vipbgc.png';
import item1 from '@/assets/imgs/list-item-1.png';
import item2 from '@/assets/imgs/list-item-2.png';
import item3 from '@/assets/imgs/list-item-3.png';
import item4 from '@/assets/imgs/list-item-4.png';
import item5 from '@/assets/imgs/list-item-5.png';
import item6 from '@/assets/imgs/list-item-6.png';
import item7 from '@/assets/imgs/list-item-7.png';
import item8 from '@/assets/imgs/list-item-8.png';
export default {
  data() {
    return {

      carouselItem: [
        {
          bgcIma: banner1
        }
      ],
      allListItem: [
        {
          imgUrl: item1,
          title: '为什么设计师创造的编程语言更受欢迎（4元/条）',
          des: '在编程的世界里，语言纷繁多样，' +
            '而大部分真正广泛流行的语言并不是那些学术界的产物，而是在通过自由发挥设计出来的。' +
            '和那些在最后期限重压下产生的语言版本比较起来，从一定程度上来看，' +
            '从学术界产生出来的编程语言是失败的。当然，并不是全部。事实早已证明。',
          btnDes: [
            {
              text: '行业分析',
              type: 'fenxi'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }
          ]
        },
        {
          imgUrl: item2,
          title: ' 2021年营销人做好微营销必备的9大思维（6元/条）',
          des: '在即将过去的2017年，微营销领域可谓变数太大，变数太多，据不完全统计代理制微商业绩下降差不多在50%左右，但是直...',
          btnDes: [{
              text: '行业分析',
              type: 'fenxi'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        },
        {
          imgUrl: item3,
          title: 'Windows多线程多任务设计初步（6元/条）',
          des: '当前流行的Windows操作系统，' +
          '它能同时运行几个程序(独立运行的程序又称之为进程)，' +
          '对于同一个程序，它又可以分成若干个独立的执行流，我们称之为线程，' +
          '线程提供了多任务处理的能力。用进程和线程的观点来研究软件是当今普遍采用的方法，' +
          '进程和线程的概念的出现，对提高软件的并行性有着重要的意义。' +
          '现在的应用软件无一不是多线程多任务处理，单线城的软件是不可想象的。' +
          '因此掌握多线程多任务设计方法对每个程序员都...',
          btnDes: [{
              text: '技术分享',
              type: 'fenxiang'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        },
        {
          imgUrl: item4,
          title: '在Linux下灵活使用expect脚本的小窍门（5元/条）',
          des: '对于喜爱自动化的Linux系统管理员而言，一定是用过expect这个命令行工具。' +
          'Expect 是由 Don Libes 基于 Tcl 语言开发的，并被广泛应用于交互式操作和自动化测试的场景之中，' +
          '它尤其适用于需要对多台服务器执行相同操作的环境中，可以大幅度提高系统管理人员的工作效率随着移动互联网时代的快速发展，' +
          '移动互联网浪潮凶猛来袭，新兴营销模式微营销的出现，很多中小型企业被打了个措手不及。中...',
          btnDes: [{
              text: '行业分析',
              type: 'fenxi'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        },
        {
          imgUrl: item5,
          title: '微营销研讨分享会 助力企业转型电商腾飞（6元/条）',
          des: '对于喜爱自动化的Linux系统管理员而言，一定是用过expect这个命令行工具。' +
          'Expect 是由 Don Libes 基于 Tcl 语言开发的，并被广泛应用于交互式操作和自动化测试的场景之中，' +
          '它尤其适用于需要对多台服务器执行相同操作的环境中，可以大幅度提高系统管理人员的工作效率',
          btnDes: [{
              text: '技术分享',
              type: 'fenxiang'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        },
        {
          imgUrl: item6,
          title: '关于Linux为什么最多能分4个扇区的解释（5元/条）',
          des: '之前有人问过为什么装Linux的时候主分区+扩展分区只能有4个，' +
          '当时由于基础知识不足，不能及时解决问题，实在有点，有点不好意思吧。 ' +
          'MBR（Master Boot Recorder）主要开机扇区,放置硬盘的信息。MBR 可以说是整个硬盘最重要的地方了，' +
          '因为在 MBR 里面记录了两个重要的东西，分别是：开机管理程序，与磁盘分割表 ( partition table )。' +
          '所以我们所做的硬盘分割，...',
          btnDes: [{
              text: '技术分享',
              type: 'fenxiang'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        },
        {
          imgUrl: item7,
          title: 'PHP开发者常犯的10个MySQL错误（5元/条）',
          des: '数据库是Web大多数应用开发的基础。如果你是用PHP，那么大多数据库用的是MYSQL也是LAMP架构的重要部分。　　PHP看起来很简单，一个初学者也可以几个小时内就能开始写函数了。但是建立一个稳定、可靠的数据库确需要时间和经验。下面就是一些这样的经验，不仅仅是MYSQL，其他数据库也一样可以参考。　　1.使用MyISAM而不是InnoDB　　MySQL有很多的数据库引擎，单一般也就用MyIS...',
          btnDes: [{
              text: '技术分享',
              type: 'fenxiang'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        },
        {
          imgUrl: item8,
          title: 'C语言编程程序的内存如何布局（5元/条）',
          des: '重点关注以下内容：　　C语言程序在内存中各个段的组成　　C语言程序连接过程中的特性和常见错误　　C语言程序的运行方式　　一：C语言程序的存储区域　　由C语言代码(文本文件)形成可执行程序(二进制文件)，需要经过编译-汇编-连接三个阶段。编译过程把C语言文本文件生成汇编程序，汇编过程把汇编程序形成二进制机器代码，连接过程则将各个源文件生成的二进制机器代码文件组合成一个文件。　　C语言编写的程序...',
          btnDes: [{
              text: '技术分享',
              type: 'fenxiang'
            },
            {
              text: '付费资讯',
              type: 'pay'
            }]
        }
      ],

      listItem: [
      ]
    }
  },
  created() {
    this.changePage(1)
  },
  methods: {
    changePage(index) {
      if(index == 1) {
        this.listItem = this.allListItem.slice(0, 4)
      } else {
        this.listItem = this.allListItem.slice(4, 8)
      }
    },
    toUserSet() {
      this.$router.push({
        path: '/userset'
      })
    },
    toNews(type) {
      this.$router.push({
        path: '/news',
        query: {
          type
        }
      })
    }
  }
}
</script>


<style scoped>
.carousel-box {
   overflow: hidden;
 }
 .item-bgc {
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
 }
 .info-box {
   width: 60%;
   height: 50%;
   background-color: transparent;
   position: absolute;
   left: 50%;
   top: 100px;
   transform: translateX(-50%);
   text-align: center;
}
 .info-box p {
   color: #fff;
   font-size: 52px;
 }
 .info-box .tips {
   font-size: 20px;
   padding: 10px 0 40px 0;
 }
 .info-box .vip-btn {
   padding: 10px 0;
   width: 200px;
   font-size: 22px;
   border: 1px solid #fff;
   margin: 0 auto;
   cursor: pointer;
 }
 .list-box {
   padding: 0px 250px;
 }
 .list-title {
   color: #009fe9;
   padding: 20px 0;
   border-bottom: 1px solid #b3b3b3;
   margin-bottom: 20px;
   cursor: pointer;
 }
.list-content {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-bottom: 20px;
}
.content-item {
  width: 40%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
  margin-top: 20px;
}
.content-item img {
  width: 100%;
  height: 200px;
}
.content-text {
  padding: 0 10px;
}
.content-title {
  font-size: 16px;
  color: #333;
  padding: 14px 0;
}
.content-des {
  color: #878787;
  white-space: normal;
  font-size: 14px;
}
.content-btns {
  display: flex;
  justify-content: flex-end;
  padding: 14px 0;
}
.page {
  text-align: center;
  padding: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/vipinfo.vue